import { isHexColor } from "./color";
import { isSingleEmoji } from "./emoji";
export type WorkspaceMark = {
  label: string | null;
  emoji: string | null;
  color: string | null;
};
export const normalizeWorkspaceMark = (raw: unknown): WorkspaceMark | null => {
  if (!raw || typeof raw !== "object") return null;
  const label =
    "label" in raw && typeof raw.label === "string"
      ? raw.label.trim() || null
      : null;
  const emoji =
    "emoji" in raw && typeof raw.emoji === "string" && isSingleEmoji(raw.emoji)
      ? raw.emoji
      : null;
  const color =
    "color" in raw && typeof raw.color === "string" && isHexColor(raw.color)
      ? raw.color.toLowerCase()
      : null;
  return label || emoji || color ? { label, emoji, color } : null;
};
